export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11386.46ab5ea1.jpg";